import { render, staticRenderFns } from "./InviteUserMultiSelect.component.vue?vue&type=template&id=23c5b238&scoped=true&"
import script from "./InviteUserMultiSelect.component.vue?vue&type=script&lang=js&"
export * from "./InviteUserMultiSelect.component.vue?vue&type=script&lang=js&"
import style0 from "./InviteUserMultiSelect.component.vue?vue&type=style&index=0&id=23c5b238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5b238",
  null
  
)

export default component.exports